import type { JSX } from 'preact';
import { ColorPickerPanel } from './colorPicker.tsx';
import { EditorDialogPanel, MapSaveDialogPanel } from './editor/dialog.tsx';
import { EditorOpenMapPanel } from './editor/openMap.tsx';
import { SceneScalePanel } from './sceneScale.tsx';
import { BoatWorkshopPanel } from './boats/workshop.tsx';
import { BotWorkshopPanel } from './bots/workshop.tsx';
import { EditorPerfPanel } from './editor/perfPanel.tsx';
import { EditorToolbarPanel } from './editor/toolbar.tsx';
import { EditorValidationPanel } from './editor/validation.tsx';
import { FpsPanel } from './fps.tsx';
import { PauseMenuPanel } from './pause/menu.tsx';
import { overlayStore } from './panels.ts';
import { PlayDebugPanel } from './play/debugPanel.tsx';
import { RaceHudPanel } from './play/raceHud.tsx';
import { TelemetryStripPanel } from './play/telemetryStrip.tsx';
import { MapSelectPanel } from './start/mapSelect.tsx';
import { useStore } from './store.ts';

/**
 * Render order is stacking order: the panels that can cover the screen come last so a modal
 * always sits above the HUD it interrupts.
 * Play HUD: raceHud + telemetry. Tool chrome: playDebug. FPS is first in the tree; `.fps-meter`
 * uses z-index 100 so the integer stays above the race plate. See docs/PLAY-HUD.md.
 */
export function OverlayRoot(): JSX.Element {
  const panels = useStore(overlayStore);

  return (
    <>
      {panels.fps ? <FpsPanel {...panels.fps} /> : null}
      {panels.editorToolbar ? <EditorToolbarPanel {...panels.editorToolbar} /> : null}
      {panels.boatWorkshop ? <BoatWorkshopPanel {...panels.boatWorkshop} /> : null}
      {panels.botWorkshop ? <BotWorkshopPanel {...panels.botWorkshop} /> : null}
      {panels.sceneScale ? <SceneScalePanel {...panels.sceneScale} /> : null}
      {panels.editorValidation ? <EditorValidationPanel {...panels.editorValidation} /> : null}
      {panels.editorPerf ? <EditorPerfPanel {...panels.editorPerf} /> : null}
      {panels.playDebug ? <PlayDebugPanel {...panels.playDebug} /> : null}
      {panels.raceHud ? <RaceHudPanel {...panels.raceHud} /> : null}
      {panels.telemetry ? <TelemetryStripPanel {...panels.telemetry} /> : null}
      {panels.mapSelect ? <MapSelectPanel {...panels.mapSelect} /> : null}
      {panels.pauseMenu ? <PauseMenuPanel {...panels.pauseMenu} /> : null}
      {panels.editorOpenMap ? <EditorOpenMapPanel {...panels.editorOpenMap} /> : null}
      {panels.editorDialog ? <EditorDialogPanel {...panels.editorDialog} /> : null}
      {panels.editorSaveDialog ? <MapSaveDialogPanel {...panels.editorSaveDialog} /> : null}
      {panels.colorPicker ? <ColorPickerPanel {...panels.colorPicker} /> : null}
    </>
  );
}
